import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';
import { NgModule } from '@angular/core';
import { ConsultarFuncionarioBicicletaComponent } from './consultar-funcionario-bicicleta.component';


const routes: Routes = [
    {  path: '', component: ConsultarFuncionarioBicicletaComponent },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  
  export class ConsultarFuncionarioBicicletaRouting { }